var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._v("\n   "+_vm._s(_vm.$t('pageNumber'))+": "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.config.id),expression:"config.id"}]},[_vm._v(_vm._s(_vm.pageNumber))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a1f3e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/PageBox/PageBox.vue
// module id = null
// module chunks = 